module.exports = __webpack_public_path__ + "static/acces-employment-logo-43caf3559f793dc6e098d1bd7c24301f.jpg";